
$views.foldermanager = {
	
	maxResultsPerPage : 100,
	descriptionsDisplayed : false,
	currentSearchTerm : '',
	
	display : function($callback, $keywordSearch) {
		
		jQuery('#folder-manager .folder-count').hide();
		
		jQuery('#foldermanager_ultrasearch').focus(function(e) {
			jQuery('#foldermanager_ultrasearch').css({'color': '#000'});
		});
		
		jQuery('#foldermanager_ultrasearch').focusout(function(e) {
			var $val = jQuery('#foldermanager_ultrasearch').val();
					
			if ($val){
				jQuery('#foldermanager_ultrasearch').css({'color': '#000'});
			} else {
				jQuery('#foldermanager_ultrasearch').css({'color': '#c2c2c2'});
			}
		});
		
		this.foldersGrid = new $soupmail.control.grid({
			model : 'folders',
			selector : '#foldermanager-folders',
			listArrayKey : 'folders',
			noResultsMessage : '<a href="#" onclick="$controllers.foldermanager.newFolder(); return false">Add a folder to get started</a>',
			paginationEnabled : true,
			paginationFrameSize : $views.foldermanager.maxResultsPerPage,
			orderingEnabled : true,
			orderingColumn : 'updated_at',
			orderingSecondaryColumn : 'reference,name',
			searchEnabled : true,
			searchControl : '#foldermanager_ultrasearch',
			searchModeAJAX : true,
			columns : [
				{ name:'favourited', label:'', cssclass:'favourite-icon', layout:'', ordering:'disabled', onAfterRender:function(item, obj) {
					if (item.favourited) {
						obj.find('.favourite-icon').addClass('favourite-icon-active');
					}
					obj.find('.favourite-icon').html('');
					if (item._isNewPrependedFolder) {
						obj.addClass('is-new-prepended-folder');
					}
				} },
				{ name:'reference', hidden:true },
				{ name:'name', label:'Folder', cssclass:'name', layout:'<div rel="tipsy" class="folder-icon"></div><a href="#" class="view">{reference}<span class="pipe">|</span>{name}</a>', ordering:'display_name', onAfterRender:function(item, obj){
					if ($models.login.getTeamid() == item.team.id) {
						if (item.custom_permissions) {
							obj.find('.folder-icon').addClass('specific');
							obj.find('.folder-icon').attr('title', 'Shared with specific people').attr('rel', 'tipsy');
						} else {
							obj.find('.folder-icon').attr('title', 'Shared with my team').attr('rel', 'tipsy');
						}
					} else {
						obj.find('.folder-icon').addClass('another-team');
						obj.find('.folder-icon').attr('title', 'Shared from another team').attr('rel', 'tipsy');
					}
				} },
				{ name:'team.name', label:'Team', cssclass:'team', layout:'', ordering:'team_name' },
				{ name:'folder_type.name', label:'Type', cssclass:'type', layout:'', ordering:'type' },
				{ name:'owner_email', label:'Owner', cssclass:'owner', layout:'', ordering:'owner_email' },
				{ name:'updated_at', label:'Updated', cssclass:'date-created', layout:'', ordering:'updated_at', onBeforeRender:function(date) {
					if (date == '---') { return '?'; }
					var $folderDate = new $soupmail.helpers.SoupMailDate(date);
					return $folderDate.getDashboardDate();
				} },
				{ name:'folder_status.name', label:'Status', cssclass:'status', layout:'', ordering:'status' },
				{ name:'description', label:'', cssclass:'description', layout:'' },
				{ name:'', label:'', cssclass:'edit-button', layout:'', onAfterRender:function(item, obj) {
					if ($models.folders.isEditable(item)) {
						obj.find('.edit-button').html('<a href="" class="edit">Edit</a>');
					}
				} },
				{ name:'', label:'', cssclass:'arrow', layout:'' },
				{ name:'', label:'', cssclass:'sharing', layout:'<div class="sharing-label">Sharing:</div>', onAfterRender:function(item, obj) {
					if (item.custom_permissions) {
						obj.find('.sharing').append('<ul class="customPermsLoading"><li class="customPerms">Loading custom permissions...</li></ul><div class="sharing-overview-grid"></div>');
					} else {
						obj.find('.sharing').append('<ul class="teamDefaultPermsList"><li><span class="email">Team Default Permissions</span><span class="permission">'+$models.folders.decodePermsSet($controllers.foldermanager.teamPermissions.permissions).decodedLabel+'</span></li></ul><div class="sharing-overview-grid"></div>');
					}
				} }
			],
			dataWrapperElem : 'div',
			dataRowElem : 'div',
			dataHeaderRowClass : 'header',
			dataHeaderElem : 'div',
			dataItemRowId : 'folder-list-item-{id}',
			dataItemRowClass : 'manage-folder-list-item',
			dataItemElem : 'div',
			dataItemsWrapperStart : '<div class="folder-list">',
			dataItemsWrapperEnd : '</div>'
		});
		this.foldersGrid.beforeSearch(function() {
			$views.foldermanager.foldersGrid.config.model = 'folders';
			$views.foldermanager.foldersGrid.config.columns[0].cssclass = 'favourite-icon';
		});
		this.foldersGrid.change(function() {
			
			// update the total count
			$views.foldermanager.updateCount();
			
			// show the folder descriptions (if set to visible)
			$views.foldermanager.showDescriptionsIfNecessary();
			
 			// add "title" tag to any Folder Name exceeding a certain character length
 			jQuery('.manage-folder-list-item .name').each(function() {
				if (jQuery(this).text().length > 20) {
					jQuery(this).attr('title', jQuery(this).find('.data_name').text());
 				}
 			});
			
 			// add "title" tag to any Team Name, Type or Owner exceeding a certain character length
 			jQuery('.manage-folder-list-item .data_team_name, .manage-folder-list-item .data_folder_type_name, .manage-folder-list-item .data_owner_email').each(function() {
				if (jQuery(this).text().length > 14) {
					jQuery(this).attr('title', jQuery(this).text());
 				}
 			});
			
			// unbind any existing event handlers
			jQuery('.header .favourite-icon').unbind('click');
			jQuery('.manage-folder-list-item *').unbind('click');
			jQuery('.manage-folder-list-item').unbind('dblclick');
			
			// bind all necessary event handlers onto each of the controls
			jQuery('.header .favourite-icon').click(function(e) {
				$views.foldermanager.toggleFavouriteFilter();
			});
			jQuery('.manage-folder-list-item a').click(function(e) {
				e.preventDefault();
			});
			jQuery('.manage-folder-list-item .favourite-icon').click(function(e) {
				if (!jQuery(this).parent().hasClass('is-new-prepended-folder')) {
					$controllers.foldermanager.toggleFavouriteFolder(jQuery(this).parent().attr('data-id'));
				}
			});
			jQuery('.manage-folder-list-item .arrow').click(function(e) {
				if (!jQuery(this).parent().hasClass('is-new-prepended-folder')) {
					$views.foldermanager.toggleFolderView(jQuery(this).parent().attr('data-id'));
				}
			});
			jQuery('.manage-folder-list-item .edit-button').click(function(e) {
				if (!jQuery(this).parent().hasClass('is-new-prepended-folder')) {
					$controllers.foldermanager.editFolder(jQuery(this).parent().attr('data-id'));
				}
			});
			jQuery('.manage-folder-list-item a.view').click(function(e) {
				if (!jQuery(this).parent().parent().hasClass('is-new-prepended-folder')) {
					$controllers.main.display({folder_ids: jQuery(this).parent().parent().attr('data-id')});
					$('.tipsy').remove();
				}
			});
			jQuery('.manage-folder-list-item').dblclick(function(e) {
				if (!jQuery(this).hasClass('is-new-prepended-folder')) {
					$controllers.main.display({folder_ids: jQuery(this).attr('data-id')});
					$('.tipsy').remove();
				}
			});
			
		});
		this.foldersGrid.load($callback);
		
		// set the keyboard focus to the search box
		jQuery('#foldermanager_ultrasearch').focus();
		
	},
	
	updateCount : function() {
		$models.folders.getSize(function($data) {
			if (parseInt($data.total_result_count)) {
				$views.foldermanager.foldersGrid.totalResultCount = $data.total_result_count;
				jQuery('#folder-manager .folder-count span').html($data.total_result_count);
				jQuery('#folder-manager .folder-count').show();
			}
		});
	},
	
	activePendingFolder : function($folderid) {
		jQuery('#folder-list-item-'+$folderid).removeClass('is-new-prepended-folder');
	},
	
	showDescriptionsIfNecessary : function() {
		if ($views.foldermanager.descriptionsDisplayed) {
			jQuery('#folder-manager').addClass('descriptions-visible');
			jQuery('.manage-folder-list-item .description').show();
			jQuery('a.hide-descriptions').addClass('toggle');
		} else {
			jQuery('#folder-manager').removeClass('descriptions-visible');
			jQuery('.manage-folder-list-item .description').hide();
			jQuery('a.hide-descriptions').removeClass('toggle');
		}
	},
	
	toggleDescriptions : function() {
		$views.foldermanager.descriptionsDisplayed = !$views.foldermanager.descriptionsDisplayed;
		$views.foldermanager.showDescriptionsIfNecessary();
	},
	
	toggleFavouriteFilter : function() {
		if (this.foldersGrid.config.model == 'folders') {
			this.foldersGrid.config.model = 'favouriteFolders';
			this.foldersGrid.config.columns[0].cssclass = 'favourite-icon header-favourite-icon-active';
		} else {
			this.foldersGrid.config.model = 'folders';
			this.foldersGrid.config.columns[0].cssclass = 'favourite-icon';
		}
		this.foldersGrid.reset();
		this.foldersGrid.load();
	},
	
	/*
renderFolders : function($data, $target, $appendNewDataToExisting) {
	
	console.log('no folders found');
	jQuery($target).html('<div class="manage-folder-list-item no-folders">
	
	
	
		No folders found.
		
		
		
	</div>');
	
},
	*/
	toggleFolderView : function($folderid) {
		
		if (jQuery('#folder-list-item-'+$folderid).hasClass('view')) {
			jQuery('#folder-list-item-'+$folderid+' .sharing').hide();
			jQuery('#folder-list-item-'+$folderid).removeClass('view');
		} else {
			jQuery('.manage-folder-list-item').removeClass('view');
			jQuery('.manage-folder-list-item .sharing').hide();
			jQuery('#folder-list-item-'+$folderid+' .sharing').show();
			jQuery('#folder-list-item-'+$folderid).addClass('view');
			delete $views.foldermanager.summaryGrid;
			if (jQuery('#folder-list-item-'+$folderid+' li').hasClass('customPerms')) {
				$views.foldermanager.renderFolderPermsSummary($folderid);
			}
		}
	},
	
	toggleFolderEditingPermsList : function($customPermissionsMode) {
		if ($customPermissionsMode) {
			jQuery('.sharing-permissions').fadeIn(function() {
				$views.all.applyBorder('#folder-modal-container #main');
				jQuery('#sharingdata_email').focus();
			});
		} else {
			jQuery('.sharing-permissions').fadeOut(function() {
				$views.all.applyBorder('#folder-modal-container #main');
			});
		}
	},
	
	renderFolderEditingScreen : function($folderid) {
	
		// cancel modal when ESC pressed
		$(document).keyup(function(e) {
			if (e.keyCode == 27) {
				jQuery('.tipsy').remove();
				$views.foldermanager.closeFolderEditingScreen();
			}
		});
		
		$template = $views._views_html['tmpl_foldereditor'];
		
		jQuery('.modal-pane').show();
		// this line doesn't work in IE8: jQuery('#folder-modal-container').html($template);
		// next line is fix for IE8:  as per http://ryreitsma.blogspot.com/2011/07/jquerys-html-and-internet-explorer-8.html
		document.getElementById('folder-modal-container').innerHTML = $template;
		jQuery('body').addClass("message-overlay");
		
		$views.foldermanager.centreFolderEditingScreen();
		
		// populate type dropdown
		jQuery('#folderdata_type').append('<option value="">- Not set -</option>');
		jQuery.each($controllers.foldermanager.types.folder_types, function($key, $type) {
			jQuery('#folderdata_type').append('<option value="'+$type.id+'">'+$type.name+'</option>');
		});
		
		// populate status dropdown
		jQuery('#folderdata_status').append('<option value="">- Not set -</option>');
		jQuery.each($controllers.foldermanager.statuses.folder_statuses, function($key, $status) {
			jQuery('#folderdata_status').append('<option value="'+$status.id+'">'+$status.name+'</option>');
		});
		
		if ($folderid) {
			
		     // get the data for this folder
		     $models.folders.getItem($folderid, function($folder) {
			
			// populate the fields
			jQuery('.folder-editor-basic .name').html($folder.name);
			jQuery('#folderdata_id').val($folder.reference);
			jQuery('#folderdata_name').val($folder.name);
			jQuery('#folderdata_description').val($folder.description);
			jQuery('#folderdata_owner').text($folder.owner_email);
			
			$models.folders.getListPerms({}, function($teamperms) {
				jQuery('.folder-editor-sharing .team-permissions').html('('+$models.folders.decodePermsSet($teamperms.permissions).decodedLabel+')');
			});

			
			jQuery('#favourite').attr('onclick', jQuery('#favourite').attr('onclick').replace('[[folderid]]', $folderid));
			
			// set type and status dropdowns appropriately
			if ($folder.folder_type) {
				jQuery('#folderdata_type').val($folder.folder_type.id);
			}
			if ($folder.folder_status) {
				jQuery('#folderdata_status').val($folder.folder_status.id);
			}
			
			// is this a favourite folder?
			if ($folder.favourited === true) {
				jQuery('#favourite').addClass('favourite-icon-active');
			}
			
			// click handler on delete button
			jQuery('#button-delete').click(function(e) {
				e.preventDefault();
				$controllers.foldermanager.deleteFolder($folderid);
				$views.foldermanager.closeFolderEditingScreen();
			});
			
			// click handler on archive button
			jQuery('#button-archive').click(function(e) {
				e.preventDefault();
				$controllers.foldermanager.archiveFolder($folderid);
				$views.foldermanager.closeFolderEditingScreen();
			});
			
			// populate custom permissions mode
			$customPermissionsMode = $folder.custom_permissions;
			if ($customPermissionsMode) {
//				$models.all.getDataFromAPI('folders/'+$folderid+'/permissions.json', '', function($perms) {
//					if ($perms.permissions.length == 0) {
//						jQuery('#sharing-me').prop('checked', true);
//					} else {
						jQuery('#sharing-custom').prop('checked', true);
						jQuery('.sharing-permissions').show();
//					}
//				});
			} else {
				jQuery('#sharing-default').prop('checked', true);
			}
			
			jQuery('#sharing-custom, #sharing-default, #sharing-me').change(function() {
				$customPermissionsMode = (jQuery('#sharing-custom').is(':checked') ? true : false);
				$views.foldermanager.toggleFolderEditingPermsList($customPermissionsMode);
			});
			
			jQuery('.folder-editor-sharing').show();
			
			$views.foldermanager.renderUserPerms();
			$views.foldermanager.renderFolderPerms($folderid);
			
			// reposition the popup lightbox to css default position and width
			jQuery('#folder-modal-container').css('marginTop', '');
			jQuery('#folder-modal-container').css('width', '');
			$views.foldermanager.centreFolderEditingScreen();
			$views.all.applyBorder('#folder-modal-container #main');
			
		     });
			
		} else {
			
			// auto-populate Reference field with last folder reference
			$models.folders.getNextReference(function(data) {
				if (data.reference) {
					jQuery('#edit-folder h2').after('<div style="float:left; padding:7px 20px 0 72px; font-style:italic">Last reference created: ' + data.reference + '</div>');
				}
			});
			
			// scroll to the top of the screen really quickly
			$views.all.scrollToTop();
			
			// change/remove/hide what we don't need
			jQuery('#edit-folder h2').html('Create new folder');
			jQuery('.folder-editor-basic #favourite').remove();
			// Changes to make it look pretty
			jQuery('.folder-editor-basic').css({paddingTop: '0px'});
			jQuery('#folderdata_status').css({marginBottom: '10px'});
			jQuery('.folder-editor-basic .name').remove();
			jQuery('.folderdata_owner_label').parent().remove();
			jQuery('#button-archive').remove();
			jQuery('#button-delete').remove();
			jQuery('#button-save').val('Add folder');
			
			// reposition the popup lightbox to middle of screen
			$views.foldermanager.centreFolderEditingScreen();
			$views.all.applyBorder('#folder-modal-container #main');
			
			// set the keyboard focus to the Reference field... NOTE: this must run BEFORE the validators are initialised!
			jQuery('#folderdata_id').focus();
			
			// get_next_folder_reference (refer #1239 for details)
/*			$models.folders.getNextReference(function($data) {
				console.log($data);
				jQuery('#folderdata_id').val($data);
			});
*/			
		}
		
		// validators
		$views.foldermanager.refValidator = new $soupmail.validator({selector: '#folderdata_id', validator: 'IMAPcompatible', failMessage: 'Please ensure you enter a reference code.  Do not include any dots or slashes.'});
		$views.foldermanager.nameValidator = new $soupmail.validator({selector: '#folderdata_name', validator: 'IMAPcompatible', failMessage: 'Please ensure you enter a folder name.  Do not include any dots or slashes.'});
		
	},
	
	centreFolderEditingScreen : function() {
		
		// reposition the popup lightbox to middle of screen
		var newMarginTop = parseInt((jQuery(window).height() - jQuery('#folder-modal-container').height()) / 2);
		if (newMarginTop < jQuery('#header').height()) {
			newMarginTop = jQuery('#header').height() + 25;
		}
		var newMarginLeft = parseInt((jQuery(window).width() - jQuery('#folder-modal-container').width()) / 2);
		if ((newMarginLeft > (jQuery(window).width() - jQuery('#folder-modal-container').width())) || (newMarginLeft < 0)) {
			newMarginLeft = 0;
		}
		jQuery('#folder-modal-container').css('paddingTop', newMarginTop + 'px');
		jQuery('#folder-modal-container').css('paddingLeft', newMarginLeft + 'px');
		jQuery('#folder-modal-container').css('top', jQuery(window).scrollTop() + 'px');
		
	},
	
	closeFolderEditingScreen : function() {
		
		jQuery('.modal-pane').hide();
		jQuery('#folder-modal-container').html('');
		jQuery("body").removeClass("message-overlay");
		$views.foldermanager.refValidator.destroy();
		$views.foldermanager.nameValidator.destroy();
		if ($views.foldermanager.addUserAutocomplete) {
			$views.foldermanager.addUserAutocomplete.destroy();
		}
		
	},
	
	renderUserPerms : function() {
		
		jQuery('#add_a_user').html('<span class="add_a_user_label">Share folder with:</span><div><input type="email" class="text" name="sharingdata_email" id="sharingdata_email" value="Enter an email address" /></div>'+$views.all.permissionsDropdown+'<input type="button" value="Add" class="add_user_button" />');
		
		jQuery('#add_a_user #sharingdata_email').keyup(function(){
			if (jQuery('#add_a_user #sharingdata_email').val()){
				jQuery('#add_a_user #sharingdata_email').css({'color': '#000'});
			}else{
				jQuery('#add_a_user #sharingdata_email').css({'color': '#c2c2c2'});
			}
		});
		
		jQuery('#add_a_user .add_user_button').click(function() {
			$controllers.foldermanager.addUserToCustomPerms();
		});
		
		$views.foldermanager.centreFolderEditingScreen();
		
	},
	
	renderFolderPermsSummaryIfNotExists : function($folderid) {
		if (!this.summaryGrid) {
			$views.foldermanager.renderFolderPermsSummary($folderid);
		}
	},
	
	renderFolderPermsSummary : function($folderid) {
		
		$models.folderpermissions.folderid = $folderid;
		
		// display the users permissions grid
		this.summaryGrid = new $soupmail.control.grid({
			model : 'folderpermissions',
			selector : '#folder-list-item-'+$folderid+' .sharing-overview-grid',
			listArrayKey : 'users',
			noResultsMessage : '<span class="email">Just me</span>',
			paginationFrameSize : 1000,
			columns : [
				{ name:'email', label:'Email address', cssclass:'email', layout:'' },
				{ name:'permissions.decodedLabel', label:'Permissions', layout:'', cssclass:'permission' },
				{ name:'status', hidden:true, onAfterRender:function(item, obj) {
					if ( (item.user && (item.user.status == 'unactivated')) || item._isNewPrependedFolder ) {
						obj.addClass('unactivated-user');
						obj.find('.email').attr('title', 'Hasn\'t been activated yet').attr('rel', 'tipsy');
					} else if (!$models.folderpermissions.hasPermissionsWithinMyTeam(item.email)) {
						obj.addClass('different-team-user');
						obj.find('.email').attr('title', 'User from a different team').attr('rel', 'tipsy');
					} else {
						obj.find('.email').attr('title', 'Active user account').attr('rel', 'tipsy');
					}
				} }
			],
			headersEnabled : false,
			dataWrapperElem : 'ul',
			dataRowElem : 'li',
			dataItemRowId : 'foldermanager-folder-user-{id}',
			dataItemRowClass : 'folder-user-item editable-grid-item',
			dataItemElem : 'span'
		});
		this.summaryGrid.change(function() {
			jQuery('#folder-list-item-'+$folderid+' ul.customPermsLoading').remove();
			jQuery('#folder-list-item-'+$folderid+' ul.teamDefaultPermsList').remove();
		});
		this.summaryGrid.load();
		
	},
	
	renderFolderPerms : function($folderid) {
		
		$models.folderpermissions.folderid = $folderid;
		
		// display the users permissions grid
		this.permsGrid = new $soupmail.control.grid({
			model : 'folderpermissions',
			selector : '#sharing_perms_grid',
			listArrayKey : 'users',
			paginationFrameSize : 1000,
			columns : [
				{ name:'email', label:'Email address', cssclass:'foldermanager_user_perms_email', layout:'' },
				{ name:'permissions.decodedLabel', label:'Permissions', layout:'', cssclass:'foldermanager_user_perms_text' },
				{ name:'permissionsDropdown', label:'Permissions', layout:$views.all.permissionsDropdown, cssclass:'foldermanager_user_perms_chooser', onAfterRender:function(permissions, obj) {
					var dropdownValue = permissions.permissions.decodedVal;
					if (dropdownValue === -1) {
						obj.find('.editbutton').remove();
					} else if (!dropdownValue) {
						dropdownValue = 3;
					}
					obj.find('select').val(dropdownValue);
				} },
				{ name:'status', hidden:true, onAfterRender:function(item, obj) {
					if ( (item.user && (item.user.status == 'unactivated')) || item._isNewPrependedFolder ) {
						obj.addClass('unactivated-user');
						obj.find('.foldermanager_user_perms_email').attr('title', 'Hasn\'t been activated yet').attr('rel', 'tipsy');
					} else if (!$models.folderpermissions.hasPermissionsWithinMyTeam(item.email)) {
						obj.addClass('different-team-user');
						obj.find('.foldermanager_user_perms_email').attr('title', 'User from a different team').attr('rel', 'tipsy');
					} else {
						obj.find('.foldermanager_user_perms_email').attr('title', 'Active user account').attr('rel', 'tipsy');
					}
				} },
				{ name:'delete', label:'Delete', layout:'<a href="#" rel="tipsy" onclick="return false" class="delete-button" title="Remove folder permissions for this user"></a>', cssclass:'deletebutton' },
				{ name:'edit', label:'Edit', layout:'<a href="#" rel="tipsy" onclick="return false" class="edit-button" title="Edit folder permissions for this user"></a>', cssclass:'editbutton', onAfterRender:function(item, obj) {
					if (item.id == $models.login.getUserid()) {
						obj.find('.editbutton').remove();
					}
				} },
				{ name:'save', label:'Save', layout:'<input type="button" value="Save" />', cssclass:'savebutton', elementName:'div' },
				{ name:'cancel', label:'Cancel', layout:'<a href="#" onclick="return false" class="cancel">Cancel</a>', cssclass:'cancelbutton', elementName:'div' }
			],
			editingEnabled : true,
			deletingEnabled : true,
			headersEnabled : false,
			dataWrapperElem : 'ul',
			dataRowElem : 'li',
			dataItemRowId : 'foldermanager-folder-user-{id}',
			dataItemRowClass : 'folder-user-item editable-grid-item',
			dataItemElem : 'span'
		});
		this.permsGrid.change(function() {
			
			// unbind any existing event handlers
			jQuery('.folder-user-item .deletebutton').die();
			jQuery('.folder-user-item .editbutton').die();
			jQuery('.folder-user-item .savebutton').die();
			jQuery('.folder-user-item .cancelbutton').die();
			
			// bind all necessary event handlers onto each of the controls
			jQuery('.folder-user-item a').click(function(e) {
				e.preventDefault();
			});
			jQuery('.folder-user-item .deletebutton').live("click", function() {
				var targetId = jQuery(this).parent().attr('data-id');
				var targetEmail = jQuery(this).parent().find('.data_email').text();
				var targetRemovalPerms = [];
				jQuery.each($controllers.foldermanager.cachedFolderPerms, function($key, $perm) {
					if ($perm.user_email == targetEmail) {
						targetRemovalPerms.push($perm.id);
					}
				});
				$models.folderpermissions.deleteItem(targetRemovalPerms.join(), function() {
					$views.foldermanager.permsGrid.removeItem(targetId);
					$views.foldermanager.summaryGrid.removeItem(targetId);
				});
			});
			jQuery('.folder-user-item .editbutton').live("click", function() {
				var thisRow = jQuery(this).parent();
				$views.teamsettings.cancelUserEditingMode();
				thisRow.find('.foldermanager_user_perms_text').hide();
				thisRow.find('.deletebutton').hide();
				thisRow.find('.editbutton').hide();
				thisRow.find('.foldermanager_user_perms_chooser').show();
				thisRow.find('.savebutton').show();
				thisRow.find('.cancelbutton').show();
			});
			jQuery('.folder-user-item .savebutton').live("click", function() {
				var thisRow = jQuery(this).parent();
				var targetId = thisRow.attr('data-id');
				var targetEmail = thisRow.find('.data_email').text();
				var perms = thisRow.find('.foldermanager_user_perms_chooser select').val();
				var permissionsData = JSON.stringify({permissions: $models.folders.encodePermsSet(targetEmail, perms)});
				$models.folderpermissions.setItem(permissionsData, function() {
					$views.foldermanager.permsGrid.changeItem(targetId, {permissions:{decodedVal:perms, decodedLabel:$models.folders.translatePermsValue(perms)}});
					$views.foldermanager.renderFolderPermsSummaryIfNotExists($models.folderpermissions.folderid);
					$views.foldermanager.summaryGrid.changeItem(targetId, {permissions:{decodedVal:perms, decodedLabel:$models.folders.translatePermsValue(perms)}});
					$views.foldermanager.summaryGrid.render();
				});
			});
			jQuery('.folder-user-item .cancelbutton').live("click", function() {
				var thisRow = jQuery(this).parent();
				thisRow.find('.foldermanager_user_perms_text').show();
				thisRow.find('.deletebutton').show();
				thisRow.find('.editbutton').show();
				thisRow.find('.foldermanager_user_perms_chooser').hide();
				thisRow.find('.savebutton').hide();
				thisRow.find('.cancelbutton').hide();
			});
			
		});
		this.permsGrid.load(function() {
			$views.foldermanager.centreFolderEditingScreen();
		});
		
		// make the "Add a user" control be an autocomplete box
		this.addUserAutocomplete = new $soupmail.control.autocomplete({
			model : 'users',
			selector : '#sharingdata_email',
			listArrayKey : 'users',
			maxResults : 10,
			column : { name:'email', cssclass:'email', layout:'{first_name} {last_name} &lt;{email}&gt;' },
			nonFilterableModel_fallback_otherColumns : ['first_name', 'last_name', 'display_name'],
			dataItemsWrapperStart : '<h2 class="people">Team Members</h2>'
		});
		this.addUserAutocomplete.resultsLoaded(function() {
			
			// unbind any existing event handlers
			jQuery('#add_a_user .autocomplete-result').die();
			
			// bind all necessary event handlers onto each of the controls
			jQuery('#add_a_user .autocomplete-result').click(function() {
				var thisRow = jQuery(this);
				var targetEmail = thisRow.find('.data_email').text();
				$views.foldermanager.addUserAutocomplete.val(targetEmail);
				$views.foldermanager.addUserAutocomplete.fadeOut();
			});
			
		});
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/views/desktop.foldermanager.js